import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getAccessToken, getSsoTokenQueryParamValue, redirectToSso } from "../../utils/authentication";

import { setLocalStorageItem } from "../../utils/storage";

const Login = () => {
	const navigate = useNavigate();

	useEffect(() => {
		async function handleLogin() {
			try {
				const ssoToken = getSsoTokenQueryParamValue();
				console.log(ssoToken)
				if (ssoToken) {
					const result = await getAccessToken(ssoToken);
					console.log(result)
					if (result?.isSuccessful) {
						setLocalStorageItem("ACCESS_TOKEN", result.result.token);
						setLocalStorageItem("E_MAIL", result.result.claims?.[0]?.name);
						setLocalStorageItem("ADMIN_ID", result.result.claims?.[6]?.name);
						navigate("/");
					} else {
						navigate("/auth-warning", { state: { errorMessage: result?.error?.message ?? "" } });
					}
				} else {
					redirectToSso();
				}
			} catch (error) {
				navigate("/auth-warning", { state: { errorMessage: "Bir Hata İle Karşılaşıldı." } });
			}
		}
		handleLogin();
	}, [navigate]);



	return (
		<div>
		</div>
	);
};

export default Login;
